/**
 *
 * FBSectionHeader
 *
 */

import React, { memo, useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';

// styles
import './style.scss';

// antd component
import { Button } from 'antd';

// utils
import {
  slugify,
  getUniqueArrayObj,
  getObjId,
} from 'utils/helpers/helper.general';



function FBExportButton({
  type,
  btnName,
  attachmentData,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-export-wrapper', type, className);

  const [csvReport, setCsvReport] = useState(false);

  const generateFormsObjecstFromData = useCallback((dataObject) => {
    if (dataObject && Array.isArray(dataObject) && dataObject?.length > 0) {
      let headersArr = [
       // { name: "ID d'étudiant", key: "studentId" },
        { name: "Prénom", key: "firstname" },
        { name: "Nom de famille", key: "lastname" },
      ];
      let data = [];
      let fileTitle = !!dataObject[0]?.title && slugify(`${dataObject[0]?.title}-${type}`) || 'form-answers-exported';

      dataObject?.map((el, indx) => {
        let stdVals = {};
        const stdAnswer = el?.answer?.[type];
        const stdAnswerList = !!stdAnswer && Object.values(stdAnswer?.data) || [];

        // std ID
        el?.student && (
          stdVals = { ...stdVals, studentId: getObjId(el?.student) }
        )
        // std name surname
        if (el?.studentData && el?.studentData?.length > 0) {
          stdVals = {
            ...stdVals,
            firstname: el?.studentData[0]?.description?.firstname,
            lastname: el?.studentData[0]?.description?.lastname,
          }
        }
        // render headers for answer
        stdAnswerList?.map((answer, aidx) => {
          headersArr.push({ name: `${answer['field-title']}`, key: `answer${aidx}` });
          if (answer['field-type'] != 'checkbox') {
            stdVals = { ...stdVals, [`answer${aidx}`]: answer[`${answer['field-type']}-answer`] }
          } else {
            if (Array.isArray(answer[`${answer['field-type']}-answer`])) {
              stdVals = { ...stdVals, [`answer${aidx}`]: answer[`${answer['field-type']}-answer`].join(';') }
            } else {
              stdVals = { ...stdVals, [`answer${aidx}`]: answer[`${answer['field-type']}-answer`] }
            }
          }
        });
        // recipient ID
        stdAnswer?.recipient && (
          stdVals = { ...stdVals, recipientId: getObjId(stdAnswer?.recipient) }
        )
        // Answer ID
        el?._ID && (
          stdVals = { ...stdVals, answerID: getObjId(el?._ID) }
        )
        // Communication ID
        el?._id && (
          stdVals = { ...stdVals, communicationId: getObjId(el?._id) }
        )
        // end
        !!stdAnswer && !!stdVals && Object.keys(stdVals)?.length > 0 && data.push(stdVals);
      });
      // add info in the end
      /*  headersArr = headersArr.concat([
        { name: "ID recipient", key: "recipientId" },
        { name: "ID de réponse", key: "answerID" },
        { name: "ID de communication", key: "communicationId" },
      ]) */

      const exportData = {
        headers: getUniqueArrayObj(headersArr, 'key'),
        items: data,
        fileTitle
      };

      return exportData;
    } else {
      return false;
    }
  }, [type]);

  const generatePlanObjecstFromData = useCallback((dataObject) => {
    if (dataObject && Array.isArray(dataObject) && dataObject?.length > 0) {
      const commData = dataObject?.[0]?.communicationData;
      let appointmentsPlan = [];
      let headersArr = [
    //    { name: "ID d'étudiant", key: "studentId" },
        { name: "Prénom", key: "firstname" },
        { name: "Nom de famille", key: "lastname" },
      ];
      let data = [];
      let fileTitle = !!commData?.title && slugify(`${commData?.title}-${type}`) || 'form-answers-exported';

      if (!!commData?.appointmentsPlan?.plan) {
        appointmentsPlan = [...commData?.appointmentsPlan?.plan];
        appointmentsPlan = appointmentsPlan.sort((a, b) => a?.slot?.date < b?.slot?.date && a?.slot?.timeFrom < b?.slot?.timeFrom)
      }


      dataObject?.map((el, indx) => {
        let stdVals = {};
        const stdAnswer = el?.answer?.[type];

        // std ID
        /*  el?.student && (
          stdVals = { ...stdVals, studentId: getObjId(el?.student) }
        ) */
        // std name surname
        if (el?.studentData && el?.studentData?.length > 0) {
          stdVals = {
            ...stdVals,
            firstname: el?.studentData[0]?.description?.firstname,
            lastname: el?.studentData[0]?.description?.lastname,
          }
        }
        // render headers for plan
        appointmentsPlan?.map((slotData, index) => {
          headersArr.push({ name: `${slotData?.slot['dateFormat']}`, key: `slot${index}` });
          if (getObjId(slotData?.student) == getObjId(el?.student)) {
            stdVals = { ...stdVals, [`slot${index}`]: slotData?.slot['timeString'] }
          } else {
            stdVals = { ...stdVals, [`slot${index}`]: '' }
          }

        })
       /*  // recipient ID
        stdAnswer?.recipient && (
          stdVals = { ...stdVals, recipientId: getObjId(stdAnswer?.recipient) }
        )
        // Answer ID
        el?._ID && (
          stdVals = { ...stdVals, answerID: getObjId(el?._ID) }
        )
        // Communication ID
        el?._id && (
          stdVals = { ...stdVals, communicationId: getObjId(el?._id) }
        ) */
        // end
        !!stdAnswer && !!stdVals && Object.keys(stdVals)?.length > 0 && data.push(stdVals);
      });
      // add info in the end
      /*  headersArr = headersArr.concat([
        { name: "ID recipient", key: "recipientId" },
        { name: "ID de réponse", key: "answerID" },
        { name: "ID de communication", key: "communicationId" },
      ]) */

      const exportData = {
        headers: getUniqueArrayObj(headersArr, 'key'),
        items: data,
        fileTitle
      };

      return exportData;
    } else {
      return false;
    }
  }, [type]);

  useEffect(() => {
    let data = null;
    if (type == 'forms') {
      data = generateFormsObjecstFromData(attachmentData);
    } else if (type == 'appointments') {
      data = generatePlanObjecstFromData(attachmentData);
    }
    !!data && setCsvReport(data);
  }, [attachmentData, type]);

  const handleExportCsv = useCallback(() => {
    const csvData = [];
    const headers = csvReport.headers.map((header) => header.name);
    csvData.push(headers);
    csvReport.items.forEach((item) => {
      const rowData = csvReport.headers.map((header) => item[header.key]);
      csvData.push(rowData);
    });
    const csv = Papa.unparse(csvData);
    // INFO: Excel (at least my version) needs the Byte Order Mark (BOM) to properly display UTF-8 content from a CSV file. You can achieve this by prepending the content with the \uFEFF unicode character in JavaScript.
    const BOM = "\uFEFF";
    const csvDataForSave = BOM + csv;
    const blob = new Blob([csvDataForSave], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${csvReport.fileTitle}.csv`);
  }, [csvReport]);

  return csvReport && (
    <div {...rest} className={childClassNames}>
      {btnName && (
        <Button
          onClick={handleExportCsv}
          className={`tcf-fb-export-button__button ${type}`}
        >
          {btnName}
        </Button>
      )}
    </div>
  );
}

FBExportButton.defaultProps = {
  type: 'forms',
  btnName: 'Exporter les résultats'
};
FBExportButton.propTypes = {
  type: PropTypes.oneOf(['appointments', 'forms']).isRequired,
  attachmentData: PropTypes.oneOfType([PropTypes.bool, PropTypes.array, PropTypes.object]),
};

export default memo(FBExportButton);
